import { render, staticRenderFns } from "./Petbrick65.vue?vue&type=template&id=f43d3b44&scoped=true"
import script from "./Petbrick65.vue?vue&type=script&lang=ts"
export * from "./Petbrick65.vue?vue&type=script&lang=ts"
import style0 from "./Petbrick65.vue?vue&type=style&index=0&id=f43d3b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43d3b44",
  null
  
)

export default component.exports